import React from 'react';
import { Button, Spinner } from 'reactstrap';
import './LoaderButton.css';
import PropTypes from 'prop-types';

export default function LoaderButton({ isLoading, className = '', disabled = false, ...props }) {
  return (
    <Button className={`LoaderButton ${className}`} disabled={disabled || isLoading} {...props}>
      {isLoading ? <Spinner size={'sm'} className="my-auto mx-auto" /> : props.children}
    </Button>
  );
}

LoaderButton.propTypes = {
  isLoading: PropTypes.bool,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.object])
};
